export default {
    "exam.title": "Mock Exam",
    "exam.locked.title": "Premium Access Only",
    "exam.locked.description": "The mock exam simulates the real conditions of the official citizenship exam.\nUnlock this feature to test your knowledge under pressure.",
    "exam.locked.cta": "Go Premium",
    "exam.ready.title": "Ready for the simulation?",
    "exam.ready.description": "You are about to take a mock exam of 20 random questions covering all chapters of the official guide.",
    "exam.ready.stats.time": "30 Min",
    "exam.ready.stats.time_label": "Time Limit",
    "exam.ready.stats.questions": "20 Qs",
    "exam.ready.stats.questions_label": "Questions",
    "exam.ready.stats.passing": "15/20",
    "exam.ready.stats.passing_label": "Passing Score",
    "exam.ready.cta": "Start Exam",
    "exam.active.question_count": "Question {{current}} of {{total}}",
    "exam.active.quit": "Quit Exam",
    "exam.active.submit": "Submit Answer",
    "exam.active.view_results": "View Results",
    "exam.active.next": "Next Question",
    "exam.result.win": "Congratulations!",
    "exam.result.lose": "Too bad...",
    "exam.result.score_win": "You passed the mock exam!",
    "exam.result.score_lose": "You did not reach the passing score.",
    "exam.result.stats.final_score": "Final Score",
    "exam.result.stats.accuracy": "Accuracy",
    "exam.result.retry": "Try Another Exam",
    "exam.result.back_home": "Back to Dashboard",
    "exam.abort.title": "Quit Exam?",
    "exam.abort.description": "All your progress on this exam will be lost. Are you sure you want to quit?",
    "exam.abort.continue": "Continue Exam",
    "exam.abort.quit": "Quit Anyway",
    "exam.badges.new": "New Badge Unlocked!",
    "exam.badges.subtitle": "YOUR EFFORT IS REWARDED",
    "exam.badges.close": "Continue My Progress"
};
